import { BehaviorSubject } from 'rxjs';
import { RentalSalesFinderFilter } from '../models/rental-sales-finder-filter.model';
import * as i0 from "@angular/core";
/**
 * Shares the Rentals/Sales Finder filter state between the landing page, the results page, and the
 * filter-list component. Mirrors {@link FboFinderFiltersService} (a root-provided BehaviorSubject).
 */
var RentalSalesFinderFiltersService = /** @class */ (function () {
    function RentalSalesFinderFiltersService() {
        this.rentalSalesFinderFilterSubject$ = new BehaviorSubject(new RentalSalesFinderFilter());
        this.rentalSalesFinderFilter = this.rentalSalesFinderFilterSubject$.asObservable();
    }
    RentalSalesFinderFiltersService.prototype.updateRentalSalesFinderFilters = function (rentalSalesFinderFilter) {
        this.rentalSalesFinderFilterSubject$.next(rentalSalesFinderFilter);
    };
    RentalSalesFinderFiltersService.ngInjectableDef = i0.defineInjectable({ factory: function RentalSalesFinderFiltersService_Factory() { return new RentalSalesFinderFiltersService(); }, token: RentalSalesFinderFiltersService, providedIn: "root" });
    return RentalSalesFinderFiltersService;
}());
export { RentalSalesFinderFiltersService };
